import { Api } from '../api/Api.js'

export async function apiStoreUpdateBankInformation(body) {
  return await Api(
    'post',
    '/bank_information/store_or_update_bank_information',
    { body }
  )
}


export async function apiGetBankInformations (uuid = null,params = {}) {
  return await Api(
    'get',
    `/bank_information/get_bank_informations${uuid && '?uuid='+uuid}` ,
    { params }
  )
}
